import instObj from '@/backend/axios-instances'

const resource = "/ticketing/category"
const instance = instObj.baseInstance

export default {
  get(ticketCategoryId, parameters) {
    return instance.get(`${resource}/${ticketCategoryId}`, { params: parameters });
  },
  put(ticketCategoryId, data) {
    return instance.put(`${resource}/${ticketCategoryId}`, data);
  },
  delete(ticketCategoryId) {
    return instance.delete(`${resource}/${ticketCategoryId}`);
  }
}
